// Lettvekts språkstøtte for Right in: Bokmål (nb) og Nynorsk (nn).
// Bokmål-teksten er nøkkel; mangler oversettelse faller vi tilbake til bokmål.
// Gjelder KUN UI-tekst – innhold lagt inn av arrangør/admin (titler, beskrivelser, steder …) røres aldri.
import { NN } from "../i18n/nn";

export const LANGS = { nb: "Bokmål", nn: "Nynorsk" };
export const DEFAULT_LANG = "nn";
const STORAGE_KEY = "rightin_lang";

function readStoredLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "nb" || v === "nn") return v;
  } catch {
    /* ignore */
  }
  return DEFAULT_LANG;
}

// ?lang=nb|nn i adressen (delingslenker, e-postlenker) vinner over lagret valg – og huskes videre.
// Parameteren fjernes fra adressefeltet etterpå, resten av søkestrengen (f.eks. nyhetsbrev-signatur) beholdes.
function readUrlLang() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const v = (params.get("lang") || "").toLowerCase();
    if (v !== "nb" && v !== "nn") return null;
    params.delete("lang");
    const rest = params.toString();
    const clean = `${window.location.pathname}${rest ? `?${rest}` : ""}${window.location.hash || ""}`;
    window.history.replaceState(window.history.state, "", clean);
    try {
      localStorage.setItem(STORAGE_KEY, v);
    } catch {
      /* ignore */
    }
    return v;
  } catch {
    return null;
  }
}

let currentLang = readUrlLang() || readStoredLang();
const listeners = new Set();

export function getLang() {
  return currentLang;
}

// Legger språkvalget på en lenke, så mottakeren åpner siden på samme målform som den som delte
export function withLang(url, lang = currentLang) {
  if (!url) return url;
  return `${url}${url.includes("?") ? "&" : "?"}lang=${lang}`;
}

export function getLocale(lang = currentLang) {
  return lang === "nn" ? "nn-NO" : "nb-NO";
}

export function setLang(lang) {
  if (lang !== "nb" && lang !== "nn") return;
  currentLang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  if (typeof document !== "undefined") document.documentElement.lang = lang;
  listeners.forEach((fn) => fn(lang));
}

export function subscribeLang(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function interpolate(str, vars) {
  if (!vars) return str;
  return str.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : m));
}

export function translate(lang, key, vars) {
  if (typeof key !== "string") return key;
  const out = lang === "nn" ? (NN[key] ?? key) : key;
  return interpolate(out, vars);
}

// For kode utenfor React-komponenter (hjelpefunksjoner, toasts i callbacks osv.)
export function tr(key, vars) {
  return translate(currentLang, key, vars);
}

if (typeof document !== "undefined") document.documentElement.lang = currentLang;
